class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      this.footerAccordion = mobileAccordion;
      this.footerAccordionIsMobile = Boolean(MinimogTheme.config.mqlMobile);
      this.footerFocusableElements = new WeakMap();
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      this.setupFooterAccordionAccessibility();
      document.addEventListener("matchMobile", () => {
        this.footerAccordionIsMobile = true;
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
        this.syncFooterAccordion();
      });
      document.addEventListener("unmatchMobile", () => {
        this.footerAccordionIsMobile = false;
        this.syncFooterAccordion();
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }

  setupFooterAccordionAccessibility() {
    if (typeof MutationObserver === "function") {
      this.footerAccordionObserver = new MutationObserver(() => this.syncFooterAccordion());
      this.footerAccordionObserver.observe(this.footerAccordion, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
      });
    } else {
      this.footerAccordion.addEventListener("click", () => {
        setTimeout(() => this.syncFooterAccordion(), 0);
      });
    }
    this.syncFooterAccordion();
  }

  syncFooterAccordion() {
    const items = this.footerAccordion.querySelectorAll(".m-accordion--item");
    items.forEach((item) => {
      const button = item.querySelector(".m-accordion--item-button");
      const content = item.querySelector(".m-accordion--item-content");
      if (!button || !content) return;

      const expanded = this.footerAccordionIsMobile ? item.classList.contains("open") : true;
      button.setAttribute("aria-expanded", String(expanded));
      content.inert = !expanded;
      if (this.footerAccordionIsMobile) {
        content.setAttribute("aria-hidden", String(!expanded));
      } else {
        content.removeAttribute("aria-hidden");
      }
      this.setFooterFocusableState(content, !expanded);
    });
  }

  setFooterFocusableState(content, collapsed) {
    const focusableElements = content.querySelectorAll("a, button, input, select, textarea, [tabindex]");
    focusableElements.forEach((element) => {
      if (collapsed) {
        if (!this.footerFocusableElements.has(element)) {
          this.footerFocusableElements.set(element, element.getAttribute("tabindex"));
        }
        element.setAttribute("tabindex", "-1");
        return;
      }

      if (!this.footerFocusableElements.has(element)) return;
      const originalTabindex = this.footerFocusableElements.get(element);
      if (originalTabindex === null) {
        element.removeAttribute("tabindex");
      } else {
        element.setAttribute("tabindex", originalTabindex);
      }
      this.footerFocusableElements.delete(element);
    });
  }
}
customElements.define("m-footer", MFooter);
